import { connect } from 'react-redux';
import {
  getCurrentUser,
  getIsMobile,
} from '@wix/da-shared-react/pkg/publicSession/selectors';
import { flagEnabled } from '@wix/da-shared-react/pkg/redux/flags/selectors';
import {
  getProfileOwnerUser,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import {
  selectors,
  CommentableTypes,
} from '@wix/da-shared-react/pkg/CommentThread';
import { Props } from './ProfileCommentsBox';

export type ConnectedPropKeys =
  | 'currentUser'
  | 'profileOwnerUser'
  | 'isOwner'
  | 'isMobile'
  | 'totalCount'
  | 'commentV2';

export default connect(
  (state): Pick<Props, ConnectedPropKeys> => {
    const currentUser = getCurrentUser(state);
    const profileOwnerUser = getProfileOwnerUser(state);
    return {
      profileOwnerUser,
      currentUser: currentUser as any, // TODO: update when CommentThread supports currentUser: null
      isOwner: isCurrentUserProfileOwner(state),
      isMobile: getIsMobile(state),
      totalCount: selectors.getTotal(
        state,
        CommentableTypes.COMMENT_USER,
        profileOwnerUser.userId
      ),
      commentV2: flagEnabled(state, 'comment_v2'),
    };
  }
);
